import api from '../../services/api';

// Modal de autorização com campo de senha oculto (substitui window.prompt,
// que exibe o texto digitado). Retorna Promise<string|null>:
//   string = senha digitada (Confirmar/Enter) OU token "liberacao:<id>" quando
//            o admin aprovou remotamente (módulo de liberação de senhas)
//   null   = cancelado (Cancelar/Esc) ou solicitação recusada/expirada
//
// opts.acao / opts.detalhes identificam a operação na tela de liberações do admin.
export default function pedirSenhaAdmin(
  mensagem = 'Esta operação exige autorização de um administrador.',
  { acao = 'autorizacao_admin', detalhes = '' } = {}
) {
  return new Promise((resolve) => {
    const overlay = document.createElement('div');
    // Marca o diálogo para os handlers globais de atalho (PDV F9, modal de
    // pagamento etc.) ignorarem teclas digitadas aqui — sem isso, letras como
    // "d"/"b"/"c" da senha disparam a troca de forma de pagamento.
    overlay.setAttribute('data-senha-admin', '1');
    overlay.style.cssText =
      'position:fixed;inset:0;background:rgba(15,23,42,.55);z-index:99999;' +
      'display:flex;align-items:center;justify-content:center;';
    // Teclas digitadas dentro do diálogo não chegam aos handlers da página
    // (fase bubble); handlers em capture precisam checar [data-senha-admin].
    for (const ev of ['keydown', 'keypress', 'keyup']) {
      overlay.addEventListener(ev, (e) => e.stopPropagation());
    }

    overlay.innerHTML = `
      <div style="background:#fff;border-radius:6px;min-width:340px;max-width:460px;
                  box-shadow:0 10px 40px rgba(0,0,0,.4);overflow:hidden;font-family:inherit">
        <div style="background:#0f2557;color:#fff;padding:10px 14px;font-size:13px;font-weight:700">
          🔒 Autorização necessária
        </div>
        <div data-corpo style="padding:14px 16px">
          <div style="font-size:13px;color:#333;margin-bottom:10px">${mensagem}</div>
          <input type="password" autocomplete="new-password" placeholder="Senha do administrador"
            style="width:100%;box-sizing:border-box;height:34px;padding:4px 10px;
                   border:1px solid #94a3b8;border-radius:4px;font-size:14px;outline-color:#1565c0" />
          <div style="display:flex;gap:8px;align-items:center;margin-top:14px">
            <button data-acao="solicitar" title="Envia a solicitação para um administrador aprovar em outra estação"
              style="height:30px;padding:0 10px;border:1px solid #b45309;border-radius:4px;
                     background:#fffbeb;color:#92400e;font-size:12px;cursor:pointer">
              📨 Solicitar liberação…
            </button>
            <span style="flex:1"></span>
            <button data-acao="cancelar"
              style="height:30px;padding:0 14px;border:1px solid #cbd5e1;border-radius:4px;
                     background:#f8fafc;font-size:13px;cursor:pointer">Cancelar</button>
            <button data-acao="ok"
              style="height:30px;padding:0 14px;border:1px solid #0f2557;border-radius:4px;
                     background:#1565c0;color:#fff;font-size:13px;font-weight:600;cursor:pointer">Confirmar</button>
          </div>
        </div>
      </div>`;

    const corpo = overlay.querySelector('[data-corpo]');
    const input = overlay.querySelector('input');
    let pollTimer = null;
    let libId = null;
    let aguardando = false;

    const fechar = (valor) => {
      if (pollTimer) clearInterval(pollTimer);
      document.removeEventListener('keydown', onEsc, true);
      overlay.remove();
      resolve(valor);
    };
    const cancelarSolicitacao = () => {
      if (libId) api.delete(`/liberacoes/${libId}`).catch(() => {});
      fechar(null);
    };
    const onEsc = (e) => {
      if (e.key === 'Escape') { e.stopPropagation(); aguardando ? cancelarSolicitacao() : fechar(null); }
    };

    // ── Modo "aguardando liberação": troca o corpo e faz polling do status ──
    const entrarEmEspera = () => {
      aguardando = true;
      corpo.innerHTML = `
        <div style="font-size:13px;color:#333;margin-bottom:6px">${mensagem}</div>
        <div data-status style="background:#fffbeb;border:1px solid #f59e0b;border-radius:4px;
             padding:10px 12px;font-size:13px;color:#92400e">
          ⏳ Solicitação <strong>#${libId}</strong> enviada — aguardando liberação do administrador…
        </div>
        <div style="display:flex;justify-content:flex-end;margin-top:14px">
          <button data-acao="desistir"
            style="height:30px;padding:0 14px;border:1px solid #cbd5e1;border-radius:4px;
                   background:#f8fafc;font-size:13px;cursor:pointer">Cancelar solicitação</button>
        </div>`;
      corpo.querySelector('[data-acao="desistir"]').onclick = cancelarSolicitacao;

      pollTimer = setInterval(async () => {
        let st;
        try { ({ data: st } = await api.get(`/liberacoes/${libId}`)); }
        catch { return; }
        if (st.status === 'aprovada') {
          fechar(`liberacao:${libId}`);
        } else if (st.status !== 'pendente') {
          clearInterval(pollTimer); pollTimer = null; aguardando = false;
          const box = corpo.querySelector('[data-status]');
          if (st.status === 'recusada') {
            box.style.cssText = box.style.cssText.replace('#fffbeb', '#fef2f2').replace('#f59e0b', '#dc2626');
            box.style.color = '#b91c1c';
            box.innerHTML = `❌ <strong>Recusada pelo administrador.</strong>` +
              (st.motivo_recusa ? `<br>Motivo: ${st.motivo_recusa}` : '');
          } else {
            box.innerHTML = '⚠️ Solicitação expirada sem resposta do administrador.';
          }
          const btn = corpo.querySelector('[data-acao="desistir"]');
          btn.textContent = 'Fechar';
          btn.onclick = () => fechar(null);
        }
      }, 3000);
    };

    overlay.querySelector('[data-acao="ok"]').onclick = () => fechar(input.value);
    overlay.querySelector('[data-acao="cancelar"]').onclick = () => fechar(null);
    overlay.querySelector('[data-acao="solicitar"]').onclick = async () => {
      try {
        const { data } = await api.post('/liberacoes', { acao, detalhes: detalhes || mensagem });
        libId = data.id;
        entrarEmEspera();
      } catch {
        alert('Erro ao enviar a solicitação de liberação.');
      }
    };
    overlay.addEventListener('mousedown', (e) => {
      if (e.target === overlay && !aguardando) fechar(null);
    });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); fechar(input.value); }
    });
    document.addEventListener('keydown', onEsc, true);

    document.body.appendChild(overlay);
    setTimeout(() => input.focus(), 30);
  });
}
